import React from 'react'
import { Rectangle } from 'recharts'

import {
  getRatingBucket,
  getSentimentColorGroup,
} from 'features/charts-v2/constants'
import type { MetricType } from 'features/charts-v2/types'

interface RoundedHorizontalBarProps extends React.ComponentProps<
  typeof Rectangle
> {
  payload?: { name?: string; count?: number }
  metricType?: MetricType
}

/**
 * Custom shape component for horizontal bars with rounded edges
 * - Positive values: rounds the right edge (bars extend rightward)
 * - Negative values: rounds the left edge (bars extend leftward)
 *
 * For sentiment/rating metrics, also emits `data-metric-bucket` so the
 * imperative hover pass in Container can highlight bars by bucket.
 */
export const RoundedHorizontalBar = (
  props: RoundedHorizontalBarProps,
): JSX.Element => {
  const { payload, metricType, ...rest } = props
  // [top-left, top-right, bottom-right, bottom-left]
  const radius: [number, number, number, number] = [0, 12, 12, 0]

  const count = payload?.count ?? 0
  const bucket =
    metricType === 'sentiment'
      ? getSentimentColorGroup(count)
      : metricType === 'rating'
        ? String(getRatingBucket(count))
        : undefined

  return (
    <Rectangle
      {...rest}
      radius={radius}
      data-row-name={payload?.name}
      data-metric-bucket={bucket}
    />
  )
}
